import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';

class JoinTeamModalStore extends BaseModalStore {
  @observable mode = 'confirm';

  @observable inviterDisplayName = '';

  @observable pending = false;

  @observable confirmDisabled = false;

  confirmJoin = noop;

  onSuccessClose = noop;

  onGoHome = noop;

  submitPromise = null;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @autobind
  prepareConfirm(inviterDisplayName) {
    if (this.pending) {
      return false;
    }

    this.mode = 'confirm';
    this.inviterDisplayName = inviterDisplayName || '';
    this.confirmDisabled = false;
    this.submitPromise = null;
    return true;
  }

  @autobind
  handleConfirm() {
    if (this.submitPromise) {
      return this.submitPromise;
    }
    if (this.pending || this.confirmDisabled || this.mode !== 'confirm') {
      return undefined;
    }

    this.pending = true;
    let submitResult;
    try {
      submitResult = this.confirmJoin();
    } catch (error) {
      submitResult = Promise.reject(error);
    }

    this.submitPromise = Promise.resolve(submitResult)
      .then(result => this.consumeSubmitResult(result), () => this.consumeSubmitResult('retryable-failure'))
      .then(result => {
        this.pending = false;
        this.submitPromise = null;
        return result;
      });

    return this.submitPromise;
  }

  @autobind
  consumeSubmitResult(result) {
    if (result === 'joined') {
      this.mode = 'success';
    } else if (result === 'committed-refresh-failure') {
      this.confirmDisabled = true;
    }
    return result;
  }

  @autobind
  closeSuccess() {
    if (this.pending || this.mode !== 'success') {
      return false;
    }

    this.closeModal();
    this.onSuccessClose();
    return true;
  }

  @autobind
  goHome() {
    if (this.pending || this.mode !== 'success') {
      return false;
    }

    this.closeModal();
    this.onGoHome();
    return true;
  }

  @autobind
  requestClose(closeModal = noop) {
    if (this.pending) {
      return false;
    }

    const successClose = this.mode === 'success';
    this.closeModal();
    if (successClose) {
      this.onSuccessClose();
    }
    closeModal();
    return true;
  }

  closeModal() {
    this.isOpen = false;
    this.isActive = false;
    this.clearStyle();
  }
}

export default JoinTeamModalStore;
